import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';
import { TOOLTIPS_TEXTS } from './tooltips';

const contactTypesTableTooltips = TOOLTIPS_TEXTS.contactTypesTable;

export const CONTACT_TYPES_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const CONTACT_TYPES_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const CONTACT_TYPES_TABLE_CONFIG: TableSource = {
  displayedColumns: [
    'name',
    // 'companyType',
    'description',
    'options'
  ],
  displayedTitles: [
    'Name',
    // 'Company Type',
    'Description',
    'Actions'
  ],
  columnsConfig: [{ sorting: true }, { sorting: true }, { sorting: true }, { sorting: false }],
  displayedTooltips: [
    contactTypesTableTooltips.name,
    // contactTypesTableTooltips.companyType,
    contactTypesTableTooltips.description
  ],
  options: null,
  dataSource: []
};
